var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M196.5 11.2c-18.3 1.8-52.3 11.5-71 20.2C66.7 59 21.5 123.2 7.6 199c-4.9 26.3-6 62.1-2.6 84.8 5.5 37.9 19.1 77.8 35.4 104.1 39.2 63 103.8 98.4 185.9 101.8l15.7.6-.7-3.4c-.4-1.9-4.1-21.8-8.3-44.4l-7.6-41-11.9-.7c-24-1.4-42.7-8.7-63.1-24.4-25.2-19.5-40.6-47.6-49.6-90.4-3.1-15-3.2-16.3-3.2-39 0-20.5.3-24.8 2.2-33.9 10.3-47.5 35-83.4 69.8-101.3 19.8-10.3 33.1-13.7 55.9-14.5 19.4-.6 28.4.6 43.3 5.9 50.9 17.9 83.9 61.5 91.8 121.3 2 15 1.3 39.8-1.5 56.6-4 23.3-16.5 53.8-28.8 70.1-3.2 4.2-5.8 7.6-5.9 7.5-.1-.1-4.8-22.3-10.4-49.2-5.6-27-10.4-49.2-10.7-49.5-.2-.2-15.7 14.9-34.5 33.7l-34.1 34.2 14.4 80.5 14.4 80.6 77.5-.1 77.5-.1 19.8-20.6c10.9-11.4 28.6-29.7 39.2-40.7 10.7-11 19.5-20.1 19.5-20.3 0-.1-20.4-.1-45.4 0-30.1.2-45.2 0-44.8-.7 26.4-39.4 39.5-71.8 45.7-112.6 3.8-24.4 3.7-70 0-92.9-6.4-39-27.2-86.2-50.4-114-13.1-15.7-30.7-32.6-41.5-39.8-15.5-10.4-38.2-21-61.4-28.8-10.5-3.5-24.4-6.1-39.7-7.4-15-1.2-50.1-1.1-63 .2z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.fb9c333db0d090509150ae9fc12fe1d4.svg";
export { ForwardRef as ReactComponent };